export default __webpack_public_path__ + "assets/bin.a8175b4f.svg";